import gql from "graphql-tag";
import {
  themeFragment,
  timesheetFragment,
} from "@/graphql/timesheets/fragments";

export const GET_UNINVOICED_TIMESHEET_ENTRIES = gql`
  query getUninvoicedTimesheetEntries($projectId: ID!, $upUntil: Date) {
    uninvoicedTimesheetEntries(projectId: $projectId, upUntil: $upUntil) {
      user {
        id
        lastName
        firstName
      }
      billable
      synced
      active
      ...TimesheetFragment
    }
  }
  ${timesheetFragment}
`;

export const GET_THEMES = gql`
  query getThemes {
    themes {
      hasMore
      items {
        ...ThemeFragment
      }
    }
  }
  ${themeFragment}
`;

export const GET_TIMERS = gql`
  query getTimers {
    timers {
      id
      date
      notes
      activityId
      periods {
        id
        startTime
        stopTime
        duration
      }
      theme {
        ...ThemeFragment
      }
      role {
        id
        name
      }
    }
  }
  ${themeFragment}
`;

export const GET_PROJECT_ROLES_FOR_USER = gql`
  query getProjectRolesForUser($projectId: ID!, $userId: ID) {
    project(id: $projectId) {
      id
      projectRoles(userId: $userId) {
        id
        name
        hourlyRate
      }
    }
  }
`;

export const GET_TIMESHEET_ROLES = gql`
  query getTimesheetRoles($projectId: ID!, $userId: ID, $date: Date!) {
    timesheetRoles(projectId: $projectId, userId: $userId, date: $date) {
      id
      name
      hourlyRate
    }
  }
`;

export const GET_ACTIVITY_TIME_SPENT = gql`
  query getActivityTimeSpent($activityIds: [ID!]) {
    activityTimeSpent(activityIds: $activityIds) {
      status
      error
      data {
        id
        activityId
        timeSpent
      }
    }
  }
`;

export const GET_DAILY_TIMESHEETS = gql`
  query getDailyTimesheets {
    getDailyTimesheets {
      status
      error
      data {
        ...TimesheetFragment
      }
    }
  }
  ${timesheetFragment}
`;

export const GET_TIMESHEET_GROUPS = gql`
  query getTimesheetGroups(
    $projectId: ID
    $filters: TimesheetGroupFilters
    $groupBy: [TimesheetGroupDimension!]!
    $level: Int!
    $parentGroupKeys: [String!]
    $offset: Int!
    $limit: Int!
  ) {
    timesheetGroups(
      projectId: $projectId
      filters: $filters
      groupBy: $groupBy
      level: $level
      parentGroupKeys: $parentGroupKeys
      offset: $offset
      limit: $limit
    ) {
      status
      error
      data {
        totals {
          totalDuration
          totalCount
          totalAmount
        }
        groups {
          key
          id
          label
          duration
          count
          latestDate
          childType
          amount
        }
        pageInfo {
          page
          pageSize
          totalItems
          totalPages
        }
      }
    }
  }
`;

export const GET_TIMESHEET_EXPLORER_ENTRIES = gql`
  query getTimesheetExplorerEntries(
    $projectId: ID
    $filters: TimesheetGroupFilters
    $parentGroupKeys: [String!]
    $offset: Int!
    $limit: Int!
  ) {
    timesheetExplorerEntries(
      projectId: $projectId
      filters: $filters
      parentGroupKeys: $parentGroupKeys
      offset: $offset
      limit: $limit
    ) {
      status
      error
      data {
        totals {
          totalDuration
          totalCount
          totalAmount
        }
        entries {
          id
          date
          duration
          notes
          projectId
          projectName
          userId
          userName
          thematicId
          thematicName
          roleId
          roleName
          hourlyRate
          amount
        }
        pageInfo {
          page
          pageSize
          totalItems
          totalPages
        }
      }
    }
  }
`;
